<template>
  <v-container>
    <h2>
      Do you have a preference on the type of financing you would like?
    </h2>

    <div class="grid-wrapper">
      <div
        v-for="loanType in loanTypes"
        :key="loanType.title">
        <button
          class="default-btn blue"
          @click.prevent="onLoanTypeSelect(loanType.name)"
        >{{ loanType.title }}</button>

        <template v-if="$vuetify.breakpoint.lgAndUp">
          <h5>{{ loanType.question }}</h5>
          <p
            v-for="(answer, aIndex) in loanType.answers"
            :key="aIndex">
            {{ loanType.answers.length > 1 ? '-' : '' }} {{ answer }}
          </p>
        </template>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'QuestionnaireLoanTypeStep',
  computed: {
    ...mapState('questionnaireStore', {
      loanTypes: ({ questions }) => questions ? questions.loanTypes : [],
    }),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async onLoanTypeSelect (item) {
      await this.updateMatchData({ loanType: item })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped>
.grid-wrapper {
  display: grid;
  justify-content: center;

  grid-template-columns: 250px;
  grid-auto-rows: 1fr;

  grid-column-gap: 35px;
  grid-row-gap: 20px;

  @include lg {
    grid-template-columns: 250px 250px 250px;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }
}

h5 {
  margin: 30px 0;
}

p {
  padding-left: 10px;
  text-indent: -10px;
}

button {
  width: 100%;
  margin: 0;
}
</style>
